import React, { useState } from 'react';
import { useAuth } from '../AuthContext';
import { validateAndSanitizeText } from '../utils/sanitization';

const JournalComponent = () => {
  const { journalEntries, saveJournalEntry } = useAuth();
  const [newEntry, setNewEntry] = useState({
    date: new Date().toISOString().split('T')[0],
    text: '',
    labels: ''
  });
  const [isAddingEntry, setIsAddingEntry] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newEntry.text.trim()) {
      // Sanitize inputs before saving
      const entry = {
        id: Date.now().toString(),
        date: newEntry.date,
        text: validateAndSanitizeText(newEntry.text.trim(), 5000),
        labels: validateAndSanitizeText(newEntry.labels.trim(), 500),
        timestamp: new Date().toISOString()
      };

      await saveJournalEntry(entry);

      setNewEntry({
        date: new Date().toISOString().split('T')[0],
        text: '',
        labels: ''
      });
      setIsAddingEntry(false);
    }
  };

  const sortedEntries = [...journalEntries].sort((a, b) => new Date(b.date) - new Date(a.date));

  return (
    <div className="journal-container">
      <div className="journal-header">
        <h2>📖 Field Journal</h2>
        <button
          className="journal-add-button"
          onClick={() => setIsAddingEntry(!isAddingEntry)}
        >
          {isAddingEntry ? 'Cancel' : 'Add Entry'}
        </button>
      </div>

      {isAddingEntry && (
        <form className="journal-form" onSubmit={handleSubmit}>
          <div className="journal-form-group">
            <label htmlFor="date">Date:</label>
            <input
              type="date"
              id="date"
              value={newEntry.date}
              onChange={(e) => setNewEntry({...newEntry, date: e.target.value})}
              required
            />
          </div>

          <div className="journal-form-group">
            <label htmlFor="text">What was done today:</label>
            <textarea
              id="text"
              rows="4"
              placeholder="Describe the work completed, observations, or notes..."
              value={newEntry.text}
              onChange={(e) => setNewEntry({...newEntry, text: e.target.value})}
              required
            />
          </div>

          <div className="journal-form-group">
            <label htmlFor="labels">Labels (space separated):</label>
            <input
              type="text"
              id="labels"
              placeholder="e.g. planting irrigation maintenance"
              value={newEntry.labels}
              onChange={(e) => setNewEntry({...newEntry, labels: e.target.value})}
            />
          </div>

          <div className="journal-form-actions">
            <button type="submit" className="journal-save-button">
              Save Entry
            </button>
          </div>
        </form>
      )}

      <div className="journal-entries">
        {sortedEntries.length === 0 ? (
          <div className="journal-empty">
            <p>No journal entries yet. Add your first entry to start tracking your field work!</p>
          </div>
        ) : (
          sortedEntries.map((entry) => (
            <div key={entry.id} className="journal-entry">
              <div className="journal-entry-header">
                <span className="journal-entry-date">{entry.date}</span>
                {entry.labels && (
                  <div className="journal-entry-labels">
                    {entry.labels.split(' ').filter(label => label.trim()).map((label, index) => (
                      <span key={index} className="journal-label">
                        {label}
                      </span>
                    ))}
                  </div>
                )}
              </div>
              <div className="journal-entry-text">{entry.text}</div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default JournalComponent;